<template>
  <div class="row">
    <div class="col-sm">
      <h4>Server limits</h4>
      <p>
        This pages shows the number of allowed connections per server, per hour.
      </p>
      <div class="alert alert-info">
        The limit value is per hour, but the server calculate per 15 minute
        window.<br />
        The default limit for server not listed here is set to 1000. So a server
        can connect up to 250 times per 15 minutes. before being blocked until
        the next 15 minute window.<br />
        If you set a value higher than 4000, it might be changed by our
        automatic cron task to be increased (but never decreased).<br />
        If you set a value lower than 4000, it won't be changed.
      </div>
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th>Domain</th>
            <th class="text-center">Limit</th>
            <th class="text-center">Action</th>
          </tr>
          <tr>
            <th>
              <input
                type="text"
                placeholder="domain.tld"
                class="form-control"
                v-model="form.domain"
              />
            </th>
            <th>
              <input
                type="number"
                placeholder="1000"
                class="form-control"
                v-model="form.limit"
              />
            </th>
            <th class="text-center">
              <a
                href="javascript:;"
                title="Add this domain now"
                class="btn btn-success btn-sm"
                @click="addServer"
                >Add</a
              >
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="server in servers"
            :key="server.name"
            :class="{
              'table-success': server.limits > 4000,
              'table-warning': server.limits < 4000,
            }"
          >
            <td>
              <router-link
                :to="{ name: 'server', query: { qs: server.name } }"
                >{{ server.name }}</router-link
              >
            </td>
            <td class="text-center">{{ server.limits }} /h</td>
            <td class="text-center">
              <a
                href="javascript:;"
                title="Unban this domain now"
                class="btn btn-danger btn-sm"
                @click="removeServer(server.name)"
                >Remove</a
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      servers: [],
      form: {
        domain: null,
        limit: null,
      },
    };
  },
  created() {
    this.getBannedServers();
  },
  methods: {
    async getBannedServers() {
      const response = await this.$http.get("limits/");
      this.servers = response.body.servers;
    },
    async addServer() {
      await this.$http.post("limits/" + this.form.domain, {
        limits: this.form.limit / 4,
      });
      this.servers.unshift({
        name: this.form.domain,
        limits: Math.ceil(this.form.limit),
      });
    },
    async removeServer(server) {
      await this.$http.delete("limits/" + server);
      const index = this.servers.findIndex((x) => x.name === server);
      if (index > -1) {
        this.servers.splice(index, 1);
      }
    },
  },
};
</script>
